
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("7QgcX", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $5b59f64a060ccca5$export$2cd8252107eb640b; });
// ====================================================================================
// collapse.module
// ====================================================================================

var $80tmL = parcelRequire("80tmL");
const $5b59f64a060ccca5$export$2cd8252107eb640b = ()=>{
    let attempts = 0;
    const whenComplete = ()=>{
        if (attempts > 30) return;
        attempts += 1;
        if (document.readyState === "complete") {
            let panels = document.querySelectorAll(".collapse");
            panels.forEach((panel)=>{
                new (0, $80tmL.Collapse)(panel, {
                    toggle: false
                });
                panel.addEventListener("show.bs.collapse", function(e) {
                    // this.classList.add("show");
                    let parent = this.closest(".panel");
                    if (parent) parent.classList.add("active");
                    let panelBtn = parent.querySelector(".panel__btn");
                    if (panelBtn) panelBtn.classList.add("panel__btn--open");
                });
                panel.addEventListener("hide.bs.collapse", function(e) {
                    // this.classList.remove("show");
                    let parent = this.closest(".panel");
                    if (parent) parent.classList.remove("active");
                    let panelBtn = parent.querySelector(".panel__btn");
                    if (panelBtn) panelBtn.classList.remove("panel__btn--open");
                });
            });
        } else setTimeout(function() {
            whenComplete();
        }, 400);
    };
    whenComplete();
};

});

parcelRegister("jHMUv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e587f90d126edbfb$export$581ff339ea0ba762; });

var $5gKb4 = parcelRequire("5gKb4");
function $e587f90d126edbfb$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $5gKb4._define_property)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("5gKb4", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $3d624443cd99befe$export$1e71eb4bef00f6b0; });
function $3d624443cd99befe$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("hYccX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d15182816097eec3$export$4fa2f4023c9cbda5; });
function $d15182816097eec3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d15182816097eec3$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $d15182816097eec3$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});


//# sourceMappingURL=collapse.module.bb343874.js.map
